
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb2ef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb2ef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $d3b706b95effddc4$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["9vqfN","index.890205b6.js","4sdAW","schoolLogo.4bdc8a73.svg","jkpZf","checkbox.07f4ed00.webp","1Fjs6","principal.fc82db61.webp","8LOnm","parenting.fe7ecbf9.png","7jK3d","ndli-logo-lg-green.7b57ef99.svg","lIGz6","whatsapp_logo.e64c035b.webp","39xy3","contact_us.30ef3343.webp","kVafO","mail_icon.55ac76c2.webp","lKIEp","WalkingDog.70e9964b.gif","big0O","WalkingDog2.3ee35919.gif","91fnp","WalkingDog3.cd722aa0.gif","foKyI","WalkingFlamingo.c3a46c81.gif","6n2Pf","WalkingPencil.a3751870.gif","37Csr","principaloffice.2e9e402b.webp","dT7wa","janmashtmi.93781cc8.webp","kHtU2","kidsclass.408b5fdc.webp","884tj","lab.666f95ee.webp","eJEzz","republicday.24f1c203.webp","fHyz9","kidszone.cb9e0422.webp","8EQKG","theaterclass.a75379fb.webp","d03fl","yogaday.df7d599c.webp","4PWAt","artclass.3ffacb2c.webp","78n7F","function1old.e422ca36.webp","fMWX6","function2old.951beffd.webp","4LkhT","function3old.63c8d4dc.webp","68xzm","function4old.101f8c77.webp","anLoV","janmashtmiold.c930d355.webp","9DUEb","rallyold.a0743803.webp","bKK6j","teachersdayold.99dc6ba4.webp","7RlLi","winnersold.e90b805c.webp","77yCi","bhartiyabhashacamp.bb38b515.webp","4p1up","blockdaywithfirstclass.13d52ec6.webp","1SUyx","cardactivitylkg.304cac06.webp","bCXYU","ganeshchaturthicelebration.330da171.webp","8koGT","index.38485892.css"]'));


//# sourceMappingURL=index.runtime.262001be.js.map
